import HTML from "./html";

/**
 * Insert script to the end of the BODY element end execute callback on load
 * @param {string}   slug     Script Identifier
 * @param {string}   src      Script src attribute
 * @param {function} callback callback to execute on script load
 * @param {boolean}  async    Whether to load script asynchronously or not
 */
export function insertScript(slug, src, callback = null, async = true) {
    if (document.getElementById(slug)) {
        if (typeof callback === 'function') {
            callback()
        }
        return
    }
    var script = document.createElement('script')
    script.id = slug
    script.src = src
    if (async) {
        script.setAttribute('async', 'true')
    }
    document.body.appendChild(script)
    if (typeof callback === 'function') {
        script.onload = callback
    }
}

/**
 * Insert stylesheet to the HEADER element
 * @param {string} slug Style identifier
 * @param {string} href Style source url
 */
export function insertStylesheet(slug, href) {
    if (document.getElementById(slug)) {
        return
    }
    var link = document.createElement('link')
    link.id = slug
    link.setAttribute('rel', 'stylesheet')
    link.setAttribute('type', 'text/css')
    link.href = href
    document.head.appendChild(link)
}

export function imagesToSvg(selector) {
    let obj = !(selector instanceof jQuery) ? $(selector) : selector
    obj.each(function() {
        var $img = $(this)
        var imgClass = $img.attr('class')
        var imgUrl = $img.attr('src')
        
        jQuery.get(imgUrl, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg')
            
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg')
            }
            
            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a')
            
            // Replace image with new SVG
            $img.replaceWith($svg)
        }, 'xml')
    })
}

export function executeInputValidation(input, regexp, errorMessage = 'Invalid field') {
    $(input).siblings().filter('span.message').remove()
    if (!input.value) {
        $(input).addClass('invalid').removeClass('valid')
        $(HTML('span').classes('message error').content('Empty field!').render()).insertAfter(input)
        return false
    } else if ((typeof regexp !== "boolean" && regexp.test(input.value)) || regexp) {
        $(input).addClass('valid').removeClass('invalid')
        return true
    } else {
        $(input).addClass('invalid').removeClass('valid')
        $(HTML('span').classes('message error').content(errorMessage).render()).insertAfter(input)
        return false
    }
}

export function validateInput(input, method) {
    switch (method) {
        case 'text' :
            return executeInputValidation(input, /[\u00c0-\u01ffa-zA-Z'\-]+[^'\-]\b/i)
        case 'email' :
            return executeInputValidation(input, /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i)
        case 'phone' :
            return executeInputValidation(input, /[()-:+\d.]+/i)
        case 'number' :
            return executeInputValidation(input, /\d+/i)
        case 'min':
            const minValue = parseInt(input.getAttribute("data-min"), 10);
            const inputValue = parseInt(input.value, 10);
            return executeInputValidation(input, inputValue > minValue, "Lägsta budet är mer än " + minValue);
        default:
            return executeInputValidation(input, /[\s\S]+/i)
    }
}